<hr>
<div id="section-title">{{sectionTitle}}</div>
<div class="row">
    <div class="column">
        <mm-condensed-label-group id="it_transactionType" [title]="labels.transactionType" [data]="transactionTypeLabel"></mm-condensed-label-group>
    </div>
    <div class="column">
        <mm-condensed-label-group id="it_useStandingAuth" [title]="labels.useStandingAuth" [data]="useStandingAuth | titlecase"></mm-condensed-label-group>
    </div>
    <div class="columns" *ngIf="useStandingAuth === 'yes' && !isStandingAuthViewPage">
        <mm-condensed-label-group id="it_standingAuthDetails" data-testid="it_standingAuthDetails" [title]="standingAuthLabel" [data]="standingAuthDetails"></mm-condensed-label-group>
    </div>
    <div class="column">
        <mm-condensed-label-group id="it_frequency" [title]="labels.frequency" [data]="frequency"></mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="frequencyDescription">
        <mm-condensed-label-group id="it_frequencyOccurrence" [title]="labels.frequencyDescription" [data]="frequencyDescription"></mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="formTransferType && !isStandingAuthViewPage">
        <mm-condensed-label-group id="it_frequency" [title]="labels.transferType" [data]="formTransferType"></mm-condensed-label-group>
    </div>

    <ng-container *ngIf="!isStandingAuthViewPage">
        <div class="column" *ngIf="!isPendingSloaSetup">
            <mm-condensed-label-group  id="it_processDate" data-testid="it_processDate" [title]="labels.processDate" [data]="itInfo.processDate | formattedDate"></mm-condensed-label-group>
        </div>
        <div class="column" *ngIf="secondProcessDate">
            <mm-condensed-label-group  id="it_secondProcessDate"  data-testid="it_secondProcessDate" [title]="labels.secondProcessDate" [data]="secondProcessDate"></mm-condensed-label-group>
        </div>
    </ng-container>
    <div *ngIf="nextProcessDate" class="column" id="itDetails_nextProcessDate" >
        <mm-condensed-label-group  id="it_nextProcessDate" data-testid="it_nextProcessDate" [title]="labels.nextProcessDate" [data]="nextProcessDate | formattedDate"></mm-condensed-label-group>
    </div>
    <div class="column" *ngIf="!isStandingAuthViewPage && endDate">
        <mm-condensed-label-group  data="it_endDate" data-testid="it_endDate" [title]="labels.endDate" [data]="endDate"></mm-condensed-label-group>
    </div>
    <ng-container *ngIf="!isStandingAuthViewPage">
        <div *ngIf="!isPendingSloaSetup" class="column">
            <mm-condensed-label-group  id="it_amount" data-testid="journalAmount" [title]="labels.amount" 
            [data]="itInfo.totalCashAmount"></mm-condensed-label-group>
        </div>
        <div class="column" *ngIf="(itInfo!.iraContributionTypeMap?.length ?? 0) > 0 && showIRAContributionType">
            <mm-condensed-label-group id="it_contributionReason"
              [title]="labels.iraContributionType" [data]="iraContributionType"></mm-condensed-label-group>
        </div>
        <div class="column" *ngIf="payIncome">
            <mm-condensed-label-group id="itDetails_payIncome" data-testid="itDetails_payIncome" class="loa loaSubmitDetails"
              data-loafieldname="{{pdfLabelsSubmitDetails.payIncome}}" [title]="labels.payIncome"
              [data]="payIncome"></mm-condensed-label-group>
        </div>
        <div *ngIf="isIraTransaction" class="column">
            <mm-condensed-label-group *ngIf="!isPendingSloaSetup" id="itDetails_grossNet"
                data-testid="itDetails_grossNet" [title]="labels.grossNet" [data]="amountType | titlecase">
            </mm-condensed-label-group>
        </div>
        <div *ngIf="isIraTransaction && !isPendingSloaSetup" class="column">
            <mm-condensed-label-group  id="itDetails_netCashAmountTotal" data-testid="itDetails_netCashAmountTotal" *ngIf="!isStandingAuthViewPage && !isPendingSloaSetup"
            [title]="labels.netCashAmount" [data]="itInfo.journalCashAmount"></mm-condensed-label-group>
        </div>
    </ng-container>

</div>
<div *ngIf="!isStandingAuthViewPage && !isTransactionViewPage" id="reviewPage_nextBusinessDayCopy" data-testid="reviewPage_nextBusinessDayCopy">{{nextBusinessDayCopy}}</div>